<!--
<div class="crm mb-25 mt-30">
  <div class="grid">
    <div class="col-5">
      <div class="Welcome-box bg-white">
        <div class="card d-flex">
          <div class="card-bg">
            <div class="card-body px-25">
              <h1 class="banner-feature__heading color-dark">Bem vindo, {{username}}!</h1>
              <p class="banner-feature__para color-dark">Este é o seu perfil como administrador, aqui poderás gerir todas as informações da plataforma.</p>
              <div class="welcome_btn_verperfil d-flex justify-content-sm-start justify-content-center">
                <a class="fs-15" (click)="userPerfil($event)">Ver perfil completo</a>
                <img src="images/img_icon.svg" alt="">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="cardmini">
        <div class="cardmini-details">
          <div class="overview-content">
            <div class="cardmini-details-content d-flex flex-wrap ">
              <div class="svg-icon">
                <img src="icons/building-07.png" alt="">
              </div>
              <div class="cardmini-details-title">
                <h1>{{totalEmpresas}}</h1>
                <p>Total de empresas</p>
              </div>
              <img class="image" src="images/img_padr_o.svg" alt="">
            </div>

          </div>
        </div>
        <div class="cardmini-details">
          <div class="overview-content">
            <div class="cardmini-details-content d-flex flex-wrap ">
              <div class="svg-icon">
                <img src="icons/building-07.png" alt="">
              </div>
              <div class="cardmini-details-title">
                <h1>{{profissionaisCount}}</h1>
                <p>Total de profissionais</p>
              </div>
              <img class="image" src="images/img_padr_o.svg" alt="">
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="contratado_plataforma">
        <div class="h-100">
          <div class="contratado_plataforma_ditails">
            <div class="ap-po-details__titlebar">
              <h1>105</h1>
              <p>Contratados via plataforma</p>
            </div>
            <div class="avatars">
              <p-avatar-group>
                <p-avatar icon="pi pi-user" shape="circle" />
                <p-avatar icon="pi pi-user" shape="circle" />
                <p-avatar icon="pi pi-user" shape="circle" />
                <p-avatar label="+100" shape="circle" />
              </p-avatar-group>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="vagas_stats_content">
        <div class="card border-0 px-25 h-100">
          <div class="row">
            <div class="col-md-4">
              <div class="overview-content w-100">
                <div class="ap-po-details-content d-flex flex-wrap">
                  <div class="ap-po-details__icon-area">
                    <div class="svg-icon bg_green order-bg-opacity-info color-info">
                      <i class="pi pi-briefcase" style="color: green"></i>
                    </div>
                  </div>
                  <div class="ap-po-details__titlebar">
                    <h1>{{tatalVagas}} </h1>
                    <p>Total de Vagas abertas</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="overview-content w-100">
                <div class=" ap-po-details-content d-flex flex-wrap">
                  <div class="ap-po-details__icon-area">
                    <div class="svg-icon bg_red order-bg-opacity-danger color-info">
                      <i class="pi pi-ban" style="color: #DB3A2C"></i>
                    </div>
                  </div>
                  <div class="ap-po-details__titlebar">
                    <h1>22</h1>
                    <p>Total de vagas encerradas</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="overview-content w-100">
                <div class=" ap-po-details-content d-flex flex-wrap">
                  <div class="ap-po-details__icon-area">
                    <div class="svg-icon bg_orange bg-opacity-warning color-info">
                      <i class="pi pi-briefcase" style="color: #E59400"></i>
                    </div>
                  </div>
                  <div class="ap-po-details__titlebar">
                    <h1>640</h1>
                    <p>Total de candidaturas</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-8">
      <div class="card recrutcharts_content">
        <div>
          <img src="images/graphic-img.png" alt="">
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card border-0">
        <div class="quantidade_profissionais_content">
          <div class="card-header px-0 border-0">
            <h5>Quantidade de profissionais</h5>
          </div>
          <form [formGroup]="selectForm" (ngSubmit)="submitForm()">
            <div class="dm-select form-group">
              <label for="tipoProfissional">Tipo de profissional</label>
              <p-select formControlName="selectedProfissional" [options]="profissionaisOption" optionLabel="name" placeholder="Seleccione o tipo de profissionais" class="w-full md:w-56" />
            </div>
          </form>
          <div class="profissionais_registrado">
            <ul>
              <li><i class="pi pi-user-plus"></i> <b>200</b> Registrado</li>
              <li><i class="pi pi-user-plus"></i> <b>200</b> Registrado</li>
              <li><i class="pi pi-user-plus"></i> <b>200</b> Registrado</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-drawer [(visible)]="visible" position="right" [style]="{'width': '720px'}"
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <ng-template #headless>
        @if (profissional) {
          <app-card-perfil [dadosPessoais]="profissional" (onCloseModal)="visible=false" ></app-card-perfil>
        }
    </ng-template>
</p-drawer> -->
<div class="w-100" style="height: 100vh">
  <app-dashboard-powerbi></app-dashboard-powerbi>
</div>